/* eslint-disable react/prefer-stateless-function */
/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import Select from 'react-select-4';
import cx from 'classnames';
import styles from './SelectDropdown.scss';

const customStyles = {
  multiValue: (provided, state) => {
    return {
      ...provided,
      backgroundColor: '#ebf5ff',
    };
  },
  multiValueLabel: (provided, state) => ({
    ...provided,
    color: '#007eff',
  }),
  control: (provided, state) => ({
    ...provided,
    cursor: 'pointer',
  }),
  option: (provided, state) => ({
    ...provided,
    cursor: 'pointer',
  }),
};

class SelectDropdown extends Component {
  render() {
    const { className, children, size, controlId, instanceId, ...props } =
      this.props;
    const classes = cx(styles.dropdown, styles[size], className);
    const inputProps = {};
    const effectiveId = controlId || instanceId;
    if (effectiveId) {
      inputProps.id = effectiveId;
    }

    return (
      <Select
        inputProps={inputProps}
        instanceId={instanceId || effectiveId}
        {...props}
        className={classes}
        styles={customStyles}
      >
        {children}
      </Select>
    );
  }
}

export default SelectDropdown;
